
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AllotService } from 'src/app/services/Allot.service';
import { AuditService } from 'src/app/services/audit.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-allot-department-audit',
  templateUrl: './allot-department-audit.component.html',
  styleUrls: ['./allot-department-audit.component.scss']
})
export class AllotDepartmentAuditComponent {
  @Input() auditData: any = {};
  AuditorForm: FormGroup | any;
  isSubmit: boolean = false;
  errorMessage: string = '';
  auditors: any[] = [];
  requestDetails: any;
  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastService: ToastService,
    private authService: AuthService,
    private finalService: FinalChecklistService,
    private auditService: AuditService,
    private router: Router,
    private allotService: AllotService, private route: ActivatedRoute) {
    this.createAuditorForm();
  }
  ngOnInit(): void {
    this.auditors = [];
    this.auditorName = [];
    this.GetMasterData();

  }
  onSave() {
    this.activeModal.close('Data saved successfully!');
  }
  createAuditorForm() {
    this.AuditorForm = this.fb.group({
      iOrderId: [0, Validators.required],
      iSocietyDetailsID: ['', Validators.required],
      iSocietyName: [''],
      iAllotAuditorID: ['', Validators.required],

      auditorTypeId: ['', Validators.required],
      auditorType: ['', Validators.required],
      auditorId: ['', Validators.required],
      auditor: ['', Validators.required],
      auditorDesignation: [''],
      auditorEmail: ['', Validators.required],
      auditorMobile: ['', Validators.required],
      createdBy: ['', Validators.required]
    });
  }
  onSubmitAuditor() {
    this.isSubmit = true;
    const userId = this.authService.currentUserValue.id;
    this.AuditorForm.controls['iSocietyDetailsID'].setValue(this.auditData.selectedSocietyId);
    this.AuditorForm.controls['iAllotAuditorID'].setValue(this.auditData.allotAuditorID);

    this.AuditorForm.controls['createdBy'].setValue(userId);
    this.AuditorForm.controls['iSocietyName'].setValue(this.auditData.societyName);
    this.AuditorForm.controls['iOrderId'].setValue(0);
    if (this.AuditorForm.invalid) {
      this.toastService.showError('Please fill required fields!');
      return;
    }
    this.finalService.allotDepartmentAuditor(this.AuditorForm.value).subscribe(
      (response) => {
        if (response.status === 200) {
          this.toastService.showSuccess(response.message);
          this.router.navigate([`/dashboard`])

          this.activeModal.close('Data saved successfully!');
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.errorMessage = 'Error fetching raised master details: ' + error.message;
        console.error('Error fetching society details:', error);
      }
    );
  }
  onChangeAuditorType() {
    const selectedType = this.AuditorForm.get('auditorTypeId')?.value;
    this.DropDownData(selectedType);
  }
  auditorName: any[] = [];
  DropDownData(auditorId: number): void {
    this.allotService.getDropDownAuditorList(auditorId).subscribe(
      (response) => {
        if (response.status === 200) {

          this.auditorName = response.data;
          const uId = this.requestDetails[0].iAuditorTypeID;
          if (uId) {
            this.AuditorForm.controls['auditorId'].setValue(uId);
            this.AuditorForm.controls['auditorId'].disable();
            this.onAuditor();
          }

          //   this.toastService.showSuccess(response.message);
        } else {
          this.toastService.showError(response.message);
          this.auditorName = [];
        }
      },
      (error) => {
        this.auditorName = [];
        this.toastService.showError(error.message);
      }
    );
  }

  onAuditor() {
    const selectedAuditorId = this.AuditorForm.get('auditorId')?.value;
    const selectedAuditor = this.auditorName.filter(auditor => auditor.iUserID == selectedAuditorId);
    this.AuditorForm.controls['auditor'].setValue(selectedAuditor[0].name);
    this.AuditorForm.controls['auditorEmail'].setValue(selectedAuditor[0].emailID);
    this.AuditorForm.controls['auditorMobile'].setValue(selectedAuditor[0].mobile);
    this.AuditorForm.controls['auditorDesignation'].setValue(selectedAuditor[0].designationName);
  }
  GetMasterData(): void {
    this.auditService.getDropDownValues().subscribe(
      (response) => {
        if (response.status === 200) {
          this.auditors = response.data.auditors;
          this.auditors = this.auditors.filter(a => a.id == 17);
          this.AuditorForm.controls['auditorTypeId'].setValue(this.auditors[0].id);
          this.AuditorForm.controls['auditorType'].setValue(this.auditors[0].name);
          this.DropDownData(this.auditors[0].id);
        } else {
          this.toastService.showError(response.message);
          this.auditors = [];
        }
      },
      (error) => {
        this.auditors = [];
        this.toastService.showError(error.message);
      },
    );
  }
  isReadonly: boolean = false;

}

